export const translations = {
    // Invoice Properties
    CommodityValue: "ערך הסחורה",
    Countryoforigin: "מדינת מקור",
    FuelCost: "עלות דלק",
    InvoiceDate: "תאריך",
    ServiceProviderName: "שם ספק",
    TransportationCost: "עלות הובלה",
    Weight: "משקל לחיוב",
    Description: "תיאור",
    Result: "תוצאה",
    ResultDescription: "הסבר",
    checkDate: "תאריך בדיקה",
    // Cost Related
    expectedFreight: "הובלה צפויה",
    invoiceFreight: "הובלה בחשבונית",
    expectedFuel: "דלק צפוי",
    invoiceFuel: "דלק בחשבונית",

    // Exchange Rates
    DollarToShekelRate: "שער חליפין בחשבונית דולר לשקל",
    exchangeRateUSDToILS: "שער חליפין דולר לשקל",
    DollarToShekelRate_Bank_of_Israel: "שער חליפין (בנק ישראל)",

    // Document Numbers
    AWBNumber: "מס' אסמכתא במסמכי השילוח",
    InvoiceBillOfLadingNumber: "מס' אסמכתא בחשבונית",
    InvoiceNumber: "חשבונית מס מספר",

    // Countries
    InvoiceOriginCountry: "מדינת המקור של החשבונית",
    AWBOriginCountry: "מדינת המקור במסמכי שילוח",

    // Weights and Values
    InvoiceWeight: "משקל החשבונית",
    AWBWeight: "משקל במסמכי השילוח",
    InvoiceValue: "ערך טובין בחשבונית",
    AWBValue: "ערך טובין במסמכי השילוח",
    value: "משקל",
    unit: "יחידת משקל בחשבונית",
    ExpectedFee: "חיוב בחשבונית",
    ReleaseFee: "חיוב שחרור במסמכי השילוח",
    HandlingFee: "חיוב טיפול במסמכי השילוח",
    // Dates
    ArrivalDate: "תאריך הגעה",
    DayBeforeInvoiceDate: "יום לפני תאריך החשבונית",

    // Payment
    paymentMethod: "צורת שילוח",
    forexAmount: 'סכום מט"ח',
    amount: "סכום",

    valueDifference: "בדיקת ערך הטובין בחשבונית לעומת שטר המטען באותו מטבע",
    originCountry: "בדיקת ארץ המוצא בחשבונית לעומת מסמכי השילוח",
    invoiceMatchesShipping: "בדיקה שחשבונית O.P.S.I אכן שייכת למסמכי השילוח",
    weightDifference: "בדיקת המשקל בחשבונית O.P.S.I לעומת נתוני השילוח במסמכים",
    DollarToShekelRateVerification: "בדיקת שיעור ההמרה בחשבונית לעומת שיעור ההמרה של בנק ישראל",
    FreightDifference: "בדיקת חיובי הובלה בחשבונית במט\"ח לעומת מחיר צפוי לפי המחירון באותו מטבע",
    FuelDifference: "בדיקת חיובי דלק בחשבונית במט\"ח לעומת מחיר צפוי לפי המחירון באותו מטבע",
    HandlingFees: "בדיקת חיובי טיפול בחשבונית לעומת מחיר צפוי לפי המחירון באותו מטבע",
    ReleaseFees: "בדיקת חיובי שחרור בחשבונית לעומת מחיר צפוי לפי המחירון באותו מטבע",

    // תרגומים חדשים:
    ShippingPriceValidation: "בדיקת מחירי שילוח מול המחירון",
    priceListValidation: "אימות מחירון",
    freightPriceMatch: "התאמת מחיר הובלה",
    fuelPriceMatch: "התאמת מחיר דלק",
    weightRounding: "עיגול משקל",
    zoneMapping: "מיפוי אזור",
    priceListNotFound: "לא נמצא מחירון מתאים",
    countryNotMapped: "מדינה לא ממופה לאזור",
    priceCalculationFailed: "נכשל בחישוב מחיר",
};

export default translations;